<template>
  <div v-if="screenData" class="view tv dark">
    <div class="id-selector">
      <div
        class="site"
        :class="{ active: index === -1 }"
        @click="
          () => {
            index = -1;
          }
        "
      >
        None
      </div>
      <div
        v-for="(site, idx) in screenData.sites"
        :key="site.id"
        class="site"
        :class="{ active: idx === index }"
        @click="
          () => {
            index = idx;
          }
        "
      >
        {{ site.name }}
      </div>
    </div>
    <Screen v-if="screenData" :data="tv4Screen6">
      <EnvironmentalGraph :index="index" :screenData="screenData" />
    </Screen>
  </div>
</template>

<script>
import Tv from './TvMixin';
import EnvironmentalGraph from '@/components/Screen/EnvironmentalGraph';

export default {
  components: {
    EnvironmentalGraph,
  },

  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    header() {
      const { averageTime } = this.screenData;
      return {
        baseline: {
          value: averageTime,
          sub: ' min',
          caption: `${this.$t('averageTimeByCurrentSite')} :`,
        },
      };
    },

    tv2Screen6() {
      const { collaboratorsCount, sites } = this.screenData;
      const value = collaboratorsCount;
      const entries = this.comuputesensibleCaseDecay().map((row, idx) => {
        const site = sites[idx];
        row.unshift(this.buildSiteBlock(site, idx));
        row.push({
          value: site.details.impact.sensibleCaseDecay.averageTime,
          sub: ' min',
        });
        return row;
      });
      return {
        heading: {
          caption: this.$t('sections.outlier'),
          icon: 'alert',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: `${this.$t('collaboratorsNumber')} :`,
            },
            {
              type: 'heading',
              caption: `${this.$t('averageAccessTime')} :`,
            },
          ],
          entries,
        },
      };
    },

    tv3Screen6() {
      const { sites } = this.screenData;
      const headerCaption = ['20 - 25 min', '25 - 30 min', '+ 30 min'];
      const entries = sites.map(site => {
        const { sensibleCaseCollaboratorsByTimeDiffRanges } = site.details;
        return sensibleCaseCollaboratorsByTimeDiffRanges.map(item => {
          return {
            value: item.count,
          };
        });
      });
      return {
        heading: {
          caption: this.$t('distributionByAccesTime'),
          icon: 'alert',
        },
        data: {
          specifications: headerCaption.map(caption => {
            return {
              type: 'heading',
              caption,
              icon: 'up',
            };
          }),
          entries,
        },
      };
    },

    tv4Screen6() {
      return {
        heading: {
          caption: this.$t('sections.environmental'),
          icon: 'environment',
        },
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });
    setTimeout(() => {
      this.$store.dispatch('updateGlobalFilters', {
        key: 'currentMatchingTime',
        value: 'private',
      });
      this.screenData = this.$store.getters.screen('tv2');
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.id-selector {
  display: flex;
  justify-content: space-around;
  background: #f5f6fa;
  padding: 24px 0;

  .site {
    padding: 12px 16px;
    border-radius: 4px;
    box-shadow:
      0 4px 8px rgba(0, 0, 0, 0.2),
      0 2px 24px 2px rgba(0, 0, 0, 0.025);
    border: solid 4px white;
    transition: 0.8s ease;
    cursor: pointer;

    &.active {
      border-color: #7f8fa6;
    }

    &:hover {
      background: #dcdde1;
      border-color: #dcdde1;
      transform: scale(1.1);
    }
  }
}
</style>
